// extracted by mini-css-extract-plugin
module.exports = {"container":"order_container__3Ybx6","detail":"order_detail__2b5o_","message":"order_message__1h2Kp"};